import React from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Statistic, Col, Row, Divider, Dropdown, Modal } from 'antd';
import RangePicker from 'components/date-range-picker';
import ProductPicker from 'components/pickers/product';

const { Search } = Input;

const ListDesktop = ({ viewModel }) => {
  const {
    data,
    filter,
    setFilterValue,
    onDateRangeFilterChange,
    onSearch,
    navigate,
    columns,
    rangePickerPresets,
    rangePickerValue,
    summary,
    paymentStatusOptions,
    shippingStatusOptions,
    internalStatuses,
    selectedOrderIds,
    setSelectedOrderIds,
    bulkActionLoading,
    bulkMenuItems,
    onBulkActionSelect,
    bulkShippingModalOpen,
    setBulkShippingModalOpen,
    bulkShippingStatus,
    setBulkShippingStatus,
    runBulkUpdateShippingStatus,
    bulkInternalModalOpen,
    setBulkInternalModalOpen,
    bulkInternalStatus,
    setBulkInternalStatus,
    runBulkUpdateInternalStatus,
  } = viewModel;

  return (
    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      <Card style={{ width: "100%" }}>
        <Space direction='vertical' style={{ width: "100%" }}>
          <Search
            placeholder="Mã đơn hàng hoặc thông tin khách hàng"
            onSearch={onSearch}
            value={filter.info}
            onChange={e => setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
          />

          <Flex gap={16}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>Trạng thái</label>
              <Select value={filter.status} style={{ width: 200 }} onChange={e => setFilterValue('status', e)}>
                <Select.Option value="proccesing">Đang xử lý</Select.Option>
                <Select.Option value="canceled">Đã huỷ</Select.Option>
                <Select.Option value="finalized">Đã hoàn tất</Select.Option>
                <Select.Option value="all">Tất cả</Select.Option>
              </Select>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>Ngày tạo</label>
              <RangePicker
                format={'DD/MM/YY'}
                presets={rangePickerPresets}
                value={rangePickerValue}
                onChange={onDateRangeFilterChange}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>Trạng thái thanh toán</label>
              <Select
                value={filter.payment_status_id ?? 'all'}
                style={{ width: 220 }}
                onChange={value => setFilterValue('payment_status_id', value)}
              >
                {paymentStatusOptions.map(item => (
                  <Select.Option key={item.id} value={item.id}>{item.title}</Select.Option>
                ))}
              </Select>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>Trạng thái vận chuyển</label>
              <Select
                value={filter.shipping_status_id ?? 'all'}
                style={{ width: 220 }}
                onChange={value => setFilterValue('shipping_status_id', value)}
              >
                <Select.Option value="all">Tất cả</Select.Option>
                {shippingStatusOptions.map(item => (
                  <Select.Option key={item.id} value={item.id}>{item.title}</Select.Option>
                ))}
              </Select>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>Trạng thái nội bộ</label>
              <Select
                value={filter.internal_status_id ?? 'all'}
                style={{ width: 220 }}
                onChange={value => setFilterValue('internal_status_id', value)}
              >
                <Select.Option value="all">Tất cả</Select.Option>
                {(internalStatuses || []).map(item => (
                  <Select.Option key={item.id} value={item.id}>{item.title}</Select.Option>
                ))}
              </Select>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', minWidth: 280 }}>
              <label>Sản phẩm</label>
              <ProductPicker
                value={filter.product_ids || []}
                onChange={value => setFilterValue('product_ids', value)}
                mode='multiple'
                placeholder='Chọn sản phẩm'
              />
            </div>
          </Flex>

          <Divider></Divider>

          <Row gutter={16}>
            <Col span={12}>
              <Statistic title="Tổng số đơn" value={summary.totalOrders} />
            </Col>
            <Col span={12}>
              <Statistic title="Tổng số tiền" value={summary.totalAmount} precision={0} />
            </Col>
          </Row>

          <Flex justify='flex-end'>
            <Button 
              type='primary' 
              onClick={() => navigate('/order/add')}
            >
              Thêm mới
            </Button>
          </Flex>
        </Space>
      </Card>

      <Card style={{ width: '100%' }}>
        <Flex justify='flex-end' align='center' style={{ marginBottom: 12 }}>
          <Space>
            {selectedOrderIds.length > 0 ? <div>{`Đã chọn: ${selectedOrderIds.length}`}</div> : null}
            <Dropdown.Button
              type='primary'
              disabled={selectedOrderIds.length === 0}
              loading={bulkActionLoading}
              menu={{ items: bulkMenuItems, onClick: onBulkActionSelect }}
            >
              Chức năng
            </Dropdown.Button>
          </Space>
        </Flex>

        <Table
          rowKey='id'
          rowSelection={{ selectedRowKeys: selectedOrderIds, onChange: (keys) => setSelectedOrderIds(keys) }}
          dataSource={data}
          columns={columns}
        />
      </Card>

      <Modal
        title='Cập nhật trạng thái vận chuyển'
        open={bulkShippingModalOpen}
        onCancel={() => setBulkShippingModalOpen(false)}
        onOk={runBulkUpdateShippingStatus}
        okText='Lưu'
        cancelText='Đóng'
        confirmLoading={bulkActionLoading}
      >
        <Select value={bulkShippingStatus} style={{ width: '100%' }} onChange={setBulkShippingStatus}>
          {shippingStatusOptions.map(item => (
            <Select.Option key={item.id} value={item.id}>{item.title}</Select.Option>
          ))}
        </Select>
      </Modal>

      <Modal
        title='Cập nhật trạng thái nội bộ'
        open={bulkInternalModalOpen}
        onCancel={() => setBulkInternalModalOpen(false)}
        onOk={runBulkUpdateInternalStatus}
        okText='Lưu'
        cancelText='Đóng'
        confirmLoading={bulkActionLoading}
      >
        <Select value={bulkInternalStatus} style={{ width: '100%' }} onChange={setBulkInternalStatus} disabled={!internalStatuses.length}>
          {internalStatuses.map(item => (
            <Select.Option key={item.id} value={item.id}>{item.title}</Select.Option>
          ))}
        </Select>
      </Modal>
    </Space>
  );
};

export default ListDesktop;
